export default __webpack_public_path__ + "static/media/fi-rr-location-alt.543ab20f.svg";